/**
 * Lloyds (LBG) mobile design tokens.
 *
 * The approved LBG mobile screens are specified in fixed pixels, not viewport
 * units — the same card has to be the same size on a 375px iPhone SE and a
 * 430px Pro Max. These tokens are the values read off those designs and are
 * only ever applied below the `sm` breakpoint; the desktop layouts keep their
 * existing `vh`/`vw` sizing untouched.
 *
 * The gutter in particular is shared by Header, Footer and PageLayout — they
 * are optically aligned, so it has to be changed in one place.
 */

import { CTA_HEIGHT } from "./cta";

/** Horizontal page padding — header, main content and footer all share it. */
export const MOBILE_GUTTER = 16;

/** White cards: payment summary, contact row, description card, bank rows. */
export const MOBILE_CARD_RADIUS = 8;
export const MOBILE_CARD_PADDING = 16;

/** Full-width stacked CTAs — same height as the desktop ones. See ./cta. */
export const MOBILE_CTA_HEIGHT = CTA_HEIGHT;

/**
 * Minimum hit area for standalone text/icon links such as the "Previous" link.
 * The label itself is only ~20px tall, which is well under the 44px touch
 * target both the LBG and the platform accessibility guidance ask for.
 */
export const MOBILE_TAP_TARGET = 44;

/**
 * Header: white merchant circle (logo or initials) and the green horse badge.
 * Sizes read off the mobile Figma — the header hugs to 108px (avatar + 16px top
 * and bottom padding, so 76px), and the badge is a fixed 55px.
 */
export const MOBILE_AVATAR = 76;
export const MOBILE_BADGE = 55;

/**
 * Mobile type scale. Headlines are GT Ultra Median (the theme's h1-h6 family),
 * everything else GT Ultra Standard.
 */
export const MOBILE_FONT = {
  headline: 26,
  // Status/terminal titles (Message, payment-success) read at the same size as
  // the journey titles on the mobile Figma.
  subHeadline: 26,
  amount: 30,
  // Card body copy sits in a 20px line box on the mobile Figma (≈14px sans).
  body: 14,
  small: 11,
  caption: 9,
  button: 14,
};

/** Status illustrations (error circle, success flag) on the terminal screens. */
export const MOBILE_ICON = {
  error: 92,
  success: 72,
};
